// extracted by css-extract-rspack-plugin
export default {"errorBody":"_4dc39790","successBody":"_d04cda4b","body":"_6e53f608","icon":"_2cd935f3"};